// Notifications profile layout view
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import StandarListView from '@/views/standard_list_layout';
import template from '@/../templates/notifications-profile-layout.hbs';
import controls_template from '@/../templates/notification-list-controls.hbs';
import notification_item from '@/../templates/notification-profile-item.hbs';
import AlertMixin from '@/mixins/alert';

var alertCh = Radio.channel('alerts');
var globalCh = Radio.channel('global');

var notification_list_template = `<form class="form"><div class="notification-collection-region"></div></form>`;
var empty_tmpl = '<div class="no-products"><p class="primary no-products">There are no new notifications for this account</p></div>';
    
// icon map for notification items
// var priority_map = {
//     info: 'fa-info-circle',
//     alert: 'fa-exclamation-triangle',
// };

var EmptyView = Marionette.View.extend({
    template: Handlebars.compile(empty_tmpl)
});

// Alert function usable by actions in this view
function show_alert(type, message) {
    return alertCh.request('showAlert', {
        message: message,
        messageType: type,
        timeout: 2000
    });
}

var NotificationItemView = Marionette.View.extend({
    template: Handlebars.compile(notification_item),
    className: 'notification-item',
    ui: {
        checkbox: 'input[type="checkbox"]',
        delete: '.delete',
        view: '.view',
    },
    events: {
        'click @ui.delete': function() {
            this.model.collection.delete([this.model]);
            show_alert('success', 'Notifications deleted');
        },
        'click @ui.view' : function() {
            globalCh.request('show_notification_dialog', this.model);
            this.model.collection.mark_read([this.model]);
        }
    },
    templateContext: function() {
        let fa;
        switch (this.model.get('priority')) {
            case 1:
                fa = 'times-circle';
                break;
            case 2:
                fa = 'exclamation-triangle';
                break;
            case 3:
                fa = 'info-circle';
                break;
            case 4:
                fa = 'info-circle';
                break;
            case 5:
                fa = 'info-circle';
                break;
            default:
                fa = 'info-circle';
        }
        return {
            n: this.model.attributes,
            fa : fa,
            unread: (this.model.get('read')) ? false : true,
        };
    },
});

// Collection view should include actions
function create_notifications_list_view(collection, options) {
    // Add collection view here
    var notification_list = new Marionette.CollectionView({
        template: Handlebars.compile(notification_list_template),
        className: 'notifications',
        ui: {
            collection_region: '.notification-collection-region',
        },
        regions: {
            collection_region: '@ui.collection_region'
        },
        select_all: function() {
            let items = $('.notifications input:checkbox');
            items.prop('checked', true);
        },
        get_selected_models: function () {
            var self = this;
            var models = [];
            $('.notifications').find('input:checkbox:checked').each(function (index, el) {
                var model;
                var id = el.getAttribute('value');
                if (!id) return;
                model = self.collection.get(id);
                if (model) models.push(model);
            });
            return models;
        },
        childView: NotificationItemView,
        collection: collection,
        collectionEvents: {
            'mark_read': 'render',
            'notification_deleted': 'render',
        },
        emptyView: EmptyView,
    });

    return notification_list;
}

function create_notification_controls(collection) {
    var notfication_controls =  new Marionette.View({
        template: Handlebars.compile(controls_template),
        ui: {
            'select_all': '.select-all',
            'delete': '.delete',
            'mark_as_read': '.mark-as-read',
            'filter_title': '.filter-title',
            'filter': '.filter',
            'label-filter': '.label-filter',
            'filter-all': '.filter.all',
            'filter-billing': '.filter.billing',
            'filter-collaboration': '.collaboration.filter',
            'prev': '.prev',
            'next': '.next',
            'notification_list': $('.notification-list'),
        },
        // clicke event for all filters that uses the data-label to decide what to filter by
        events: {
            'click @ui.label-filter': function(e) {
                this.triggerMethod('filter_by', e.currentTarget.dataset.label);
            },
            'click @ui.filter': function(e) {
                // Ensure the dropdown closes and the title changes
                this.ui.filter_title.html(e.currentTarget.text);
                this.$el.find('.dropdown.filters').removeClass('open');
            }
        },
        // bulk actions that do not need the UI element target
        triggers: {
            'click @ui.filter-all': 'filter-all',
            'click @ui.select_all': 'select_all',
            'click @ui.delete': 'delete_notification',
            'click @ui.mark_as_read': 'mark_as_read',
        },
        // We need the orginal event target to know what to filter by, so this isn't a trigger
        onFilter_by: function(label) {
            collection.reset();
            collection.fetch({
                data: {
                    'filter[label]': label
                }
            });
        }
    });

    return notfication_controls;
}

var NotificationsProfileView = StandarListView.extend(AlertMixin).extend({
    className: 'standard-layout',
    id: 'notifications-profile',
    template: Handlebars.compile(template),
    title: 'Notifications Center',
    ui: {
        notifications_region: '.content-region',
        bulk_controls: '.controls > .group',
        form: '.form',
        title: '.title',
    },
    regions: {
        notifications_region: '@ui.notifications_region',
        bulk_controls: '@ui.bulk_controls',
        pagination_controls: '.pagination',
    },
    initialize: function() {
        
    },
    templateContext: function () {
        return {
            title: this.getOption('title') || 'Untitled',
        };
    },
    onRender: function() {
        var notification_list = create_notifications_list_view(this.collection);
        var notification_controls = create_notification_controls(this.collection);

        // Listeners for bulk control actions
        notification_list.listenTo(notification_controls, 'select_all', function() {
            notification_list.options.select_all();
        });

        notification_list.listenTo(notification_controls, 'delete_notification', function () {
            var selected_models = this.options.get_selected_models();
            if (this.collection.length < 1) {
                return;
            }

            this.collection.delete(selected_models)
                .then(function(){
                    show_alert('success', 'Notifications deleted');
                });
        });

        notification_list.listenTo(notification_controls, 'mark_as_read', function () {
            var selected_models = this.options.get_selected_models();
            this.collection.mark_read(selected_models);
        });

        notification_list.listenTo(notification_controls, 'filter-all', function () {
            this.collection.reset();
            this.collection.fetch();
        });

        notification_list.listenTo(notification_controls, 'filter-billing', function (e) {
            this.collection.fetch({
                data: {
                    'filter[label]': 'billing'
                }
            });
        });

        this.showChildView('notifications_region', notification_list);
        this.showChildView('bulk_controls', notification_controls);

        notification_list.listenTo(notification_list.collection, 'sync', function () {
            
        });
    },
    
});


export default NotificationsProfileView;


